import React, { useState } from 'react';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import CustomModal from '../../../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../../../utils/safeHTML';
import { useModal } from '../../../../../hooks/useModal';
import UserBillet from '../../../../features/userBillet';
import Scrollbar from 'react-scrollbars-custom';
import Item from '../Item/Item';
import { useTranslation } from '../../../../../translations';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import useActiveItem from '../../model/hooks/useActiveItem';
import useButtonCallbacks from '../../model/hooks/useButtonCallbacks';
import { isNumber } from 'lodash';
import useHandleBuyRequest from '../../model/hooks/useHandleBuyReuest';
import { SEND } from '../../constants/actions';
import content from '../../constants/content';
import { customizationScrollbarSettings } from '../../../../../constants/copyright';
import { useContent } from '../../../../../redux/reducer/content';
import StatusPanel from '../../../../baseComponents/gui/statusPanel/StatusPanel';
import classNames from 'classnames';
import { useRequests } from '../../../../../redux/reducer/requests';

const { title, buttons } = content;

export default function GiftChooseModal({ shopItems }) {
  const { viewedFriend } = useContent();
  const [activeShopItem, setActiveShopItem] = useState();
  const activeShopItemObject = useActiveItem({ activeShopItem, shopItems });
  const buttonCallbacks = useButtonCallbacks({ activeShopItemObject });

  const callbacks = useApplicationCallbacks();
  const { addModal } = useModal();
  const { t } = useTranslation();

  const {
    authData: { isWeb },
  } = useRequests();

  useHandleBuyRequest();

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']} className={'custom-modal_fullpage'}>
      <div className={classNames('gift-choose', { 'gift-choose_app': !isWeb })}>
        <div className={'gift-choose__content'}>
          <div className={'gift-choose__header'}>
            <div className={'gift-choose__title'}>{safeHTML(t(title))}</div>
            <StatusPanel callbacks={callbacks} type={'gift-choose'} mod={'dark'} noChangeFontSize={true} />
          </div>
          <UserBillet userData={viewedFriend} onClick={() => addModal({ type: 'profileModal' })} />
          <div className={'gift-choose__list'}>
            <Scrollbar {...customizationScrollbarSettings}>
              <div className={'gift-choose__items'}>
                {shopItems.map((item, index) => (
                  <Item
                    key={item.id}
                    {...item}
                    active={activeShopItem}
                    setActiveShopItem={setActiveShopItem}
                    index={index}
                  />
                ))}
              </div>
            </Scrollbar>
          </div>
          <div className={'gift-choose__buttons'}>
            {buttons.map((button) => (
              <CustomButton
                key={button.action}
                disabled={SEND === button.action && !isNumber(activeShopItem)}
                {...button}
                onClick={buttonCallbacks[button.action]}
              />
            ))}
          </div>
        </div>
      </div>
    </CustomModal>
  );
}
